var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hoisting-collapse-content workpermit-content-slot" },
    [
      _c("HoistingDetail", {
        attrs: {
          showOperate: _vm.showOperate,
          showPrint: _vm.showPrint,
          isEdit: _vm.isEdit,
          isProjectAvailable: _vm.isProjectAvailable,
          hoistingData: _vm.permitData,
          floorsOptions: _vm.floorsOptions,
          isPPSuspened: _vm.isPPSuspened,
          operationCb: _vm.operationCb,
        },
      }),
      _vm._v(" "),
      _vm.isolatedDevicesRecommendation
        ? _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("workPermit.isolatedDeviceRecommendation"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "last-update" },
              _vm._l(_vm.isolatedDevicesRecommendation, function (text, index) {
                return _c("div", { key: text, staticClass: "tender-font" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(index + 1) +
                      ". " +
                      _vm._s(text) +
                      "\n      "
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.afterOfficeHoursReviewedInfo.who && _vm.isHKlandUser
        ? _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("workPermit.commentsfromReviewer"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "last-update" }, [
              _c("div", { staticClass: "last-update__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("workPermit.reviewedBy", [
                        _vm.afterOfficeHoursReviewedInfo.who,
                        _vm.afterOfficeHoursReviewedInfo.when,
                      ])
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("pre", [
              _vm._v(
                _vm._s(
                  _vm._f("isEmptyValue")(
                    _vm.afterOfficeHoursReviewedInfo.content
                  )
                )
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.rejectInfo && _vm.rejectInfo.who
        ? _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
            _c("strong", [_vm._v(_vm._s(_vm.rejectInfoSubject))]),
            _vm._v(" "),
            _c("div", { staticClass: "last-update" }, [
              _c("div", { staticClass: "last-update__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(_vm.hoistingRejectBylineKey, [
                        _vm.rejectInfo.who,
                        _vm.rejectInfo.when,
                      ])
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("pre", [
              _vm._v(_vm._s(_vm._f("isEmptyValue")(_vm.rejectInfo.content))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.approveInfo && _vm.approveInfo.who
        ? _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("workPermit.commentsfromApprover"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "last-update" }, [
              _c("div", { staticClass: "last-update__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(_vm.hoistingApproveBylineKey, [
                        _vm.approveInfo.who,
                        _vm.approveInfo.when,
                      ])
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("pre", [
              _vm._v(_vm._s(_vm._f("isEmptyValue")(_vm.approveInfo.content))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showOneStepWorkflow
        ? _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
            _c(
              "div",
              { staticClass: "workpermit-content-slot__recommendation" },
              [
                _c(
                  "p",
                  {
                    staticClass: "workpermit-content-slot__recommendation_hint",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("workPermit.plsInputRecommendationToHoisting")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("IsolatedDeviceOptions", { ref: "isoDeviceOptions" }),
                _vm._v(" "),
                _c("div", { staticClass: "workpermit-content-slot__btns" }, [
                  _c(
                    "p",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openPermitsAtLocation()
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/ic_permits_at_location.png",
                          alt: _vm.permitsAtLocationLabel,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.permitsAtLocationLabel) +
                            " (" +
                            _vm._s(_vm.permitsAtSameLocationCount) +
                            ")"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      on: {
                        click: function ($event) {
                          return _vm.openRejectModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.rejectAction")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      on: {
                        click: function ($event) {
                          return _vm.openApproveModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.approveAction")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showTwoStepsWorkflowFirstStep
        ? [
            _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
              _c(
                "div",
                { staticClass: "workpermit-content-slot__recommendation" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "workpermit-content-slot__recommendation_hint",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "workPermit.plsInputRecommendationToHoisting"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("IsolatedDeviceOptions", { ref: "isoDeviceOptions" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "workpermit-content-slot__btns" }, [
                    _c(
                      "p",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openPermitsAtLocation()
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/ic_permits_at_location.png",
                            alt: _vm.permitsAtLocationLabel,
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.permitsAtLocationLabel) +
                              " (" +
                              _vm._s(_vm.permitsAtSameLocationCount) +
                              ")"
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--darkblue",
                        on: {
                          click: function ($event) {
                            return _vm.openRejectModal()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("action.rejectAction")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--orange",
                        on: {
                          click: function ($event) {
                            return _vm.openNextReviewerModal()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("tenantProjects.submission.nextReviewer")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "WorkPermNextReviewerModal",
              {
                ref:
                  _vm.WP_ACTION_TYPE.HPApprove +
                  "_nextReviewerModal_" +
                  _vm.permitData.id,
                attrs: {
                  modalId:
                    _vm.WP_ACTION_TYPE.HPApprove +
                    "_nextReviewerModal_" +
                    _vm.permitData.id +
                    "-" +
                    +new Date(),
                  modalType: "medium-modal",
                },
                on: { "multi-select-submited": _vm.confirmNextReviewer },
              },
              [
                _c(
                  "div",
                  {
                    attrs: { slot: "wp-next-reviewer-content" },
                    slot: "wp-next-reviewer-content",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "workpermit-content-slot__comments-box" },
                      [
                        _c("TextField", {
                          directives: [
                            { name: "hkldinput", rawName: "v-hkldinput" },
                          ],
                          staticClass:
                            "workpermit-content-slot__comments-textarea",
                          attrs: {
                            value: _vm.comments,
                            readonly: false,
                            required: false,
                            showColon: false,
                            label: _vm.$t("typeComments"),
                          },
                          on: {
                            updateValue: function (val) {
                              return (_vm.comments = val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showTwoStepsWorkflowSecondStep
        ? _c("div", { staticClass: "workpermit-content-slot__review-box" }, [
            _c(
              "div",
              { staticClass: "workpermit-content-slot__recommendation" },
              [
                _c("div", { staticClass: "workpermit-content-slot__btns" }, [
                  _c(
                    "p",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openPermitsAtLocation()
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/ic_permits_at_location.png",
                          alt: _vm.permitsAtLocationLabel,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.permitsAtLocationLabel) +
                            " (" +
                            _vm._s(_vm.permitsAtSameLocationCount) +
                            ")"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      on: {
                        click: function ($event) {
                          return _vm.openRejectModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.rejectAction")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      on: {
                        click: function ($event) {
                          return _vm.openApproveModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.approveAction")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showHoistBox && _vm.canBmoHoist
        ? _c(
            "div",
            {
              key: "isolated-info-" + _vm.permitData.id,
              class: [
                "workpermit-content-slot__review-box_row",
                "isolated-info-" + _vm.permitData.id,
              ],
            },
            [
              _c(
                "div",
                { staticClass: "isolated-info" },
                [
                  _c("InputField", {
                    staticClass: "small-3 medium-3 large-3 condition column",
                    attrs: {
                      label: _vm.$t("workPermit.isolatedBy"),
                      showColon: false,
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return (_vm.isolatedBy = val)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "small-6 medium-6 large-6 condition column",
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "required-flag date-time-selector-title",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("workPermit.isolatedTime")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("DateTimeSelector", {
                        attrs: {
                          showClearBtn: true,
                          setMinTime: true,
                          required: true,
                        },
                        on: {
                          updateDate: function (val) {
                            return (_vm.isolatedTime = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn--darkblue",
                      on: { click: _vm.startHoist },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("workPermit.hoist")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isolatedInfo.content
        ? _c("div", { class: ["workpermit-content-slot__review-box_row"] }, [
            _c("div", { staticClass: "isolated-info" }, [
              _c("div", { staticClass: "updatedBy" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("workPermit.isolatedBy")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.isolatedInfo.content &&
                        _vm.isolatedInfo.content.isolatedBy
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "updatedTime" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("workPermit.isolatedTime")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.isolatedInfo.content &&
                        _vm.dateFormat(_vm.isolatedInfo.content.isolatedTime)
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "gray-font" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(_vm.hoistingActionFooterBylineKey, [
                        _vm.isolatedInfo.who,
                        _vm.isolatedInfo.when,
                      ])
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showReHoistBox && _vm.canBmoHoist
        ? _c(
            "div",
            {
              key: "checked-info-" + _vm.permitData.id,
              class: [
                "workpermit-content-slot__review-box_row",
                "checked-info-" + _vm.permitData.id,
              ],
            },
            [
              _c(
                "div",
                { staticClass: "checked-info" },
                [
                  _c("InputField", {
                    staticClass: "small-3 medium-3 large-3 condition column",
                    attrs: {
                      label: _vm.$t("workPermit.deHoistedBy"),
                      showColon: false,
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return (_vm.checkedBy = val)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "small-6 medium-6 large-6 condition column",
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "required-flag date-time-selector-title",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("workPermit.deHoistedTime")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("DateTimeSelector", {
                        attrs: {
                          showClearBtn: true,
                          setMinTime: true,
                          required: true,
                        },
                        on: {
                          updateDate: function (val) {
                            return (_vm.checkedTime = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn--darkblue",
                      on: { click: _vm.completeHoist },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("workPermit.deHoist")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkedInfo.content
        ? _c("div", { class: ["workpermit-content-slot__review-box_row"] }, [
            _c("div", { staticClass: "checked-info" }, [
              _c("div", { staticClass: "updatedBy" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("workPermit.deHoistedBy")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.checkedInfo.content &&
                        _vm.checkedInfo.content.checkedBy
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "updatedTime" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("workPermit.deHoistedTime")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.checkedInfo.content &&
                        _vm.dateFormat(_vm.checkedInfo.content.checkedTime)
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "gray-font" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(_vm.hoistingActionFooterBylineKey, [
                        _vm.checkedInfo.who,
                        _vm.checkedInfo.when,
                      ])
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showHint
        ? _c("pre", {
            staticClass: "hoisting__hint",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("termsAndConditions.hoistingHintText." + _vm.regionName)
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "hoistingModal_" + _vm.permitData.id,
          attrs: {
            modalId: "hoistingModal-" + _vm.permitData.id + "-" + +new Date(),
            modalType: "medium-modal",
            beforeOpenModal: _vm.beforeOpenModal,
            beforeCloseModal: _vm.beforeCloseModal,
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "font-bold",
              class: {
                "required-flag":
                  _vm.modalStatus === _vm.$t("action.rejectAction"),
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.hoistingActionConfirmHint) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "workpermit-content-slot__comments-box",
              attrs: { id: "hp-comments-" + _vm.permitData.id },
            },
            [
              _c("TextField", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "workpermit-content-slot__comments-textarea",
                attrs: {
                  placeholder: _vm.$t("typeComments"),
                  value: _vm.comments,
                  readonly: false,
                  required: true,
                },
                on: {
                  updateValue: function (val) {
                    return (_vm.comments = val)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: { click: _vm.closeModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.modalStatus === _vm.$t("action.approveAction")
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    on: { click: _vm.approve },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.approveAction")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.modalStatus === _vm.$t("action.rejectAction")
              ? _c(
                  "button",
                  { staticClass: "btn btn--orange", on: { click: _vm.reject } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.rejectAction")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }